import ky from "ky";

export function setCookie(cname, cvalue, time) {
	let d = new Date();
	let expires = "";

	if (time) {
		time = time * 24 * 60 * 60 * 1000;
		d.setTime(d.getTime() + time);
		expires = d.toUTCString();
	}
	document.cookie = `${cname}=${cvalue};expires=${expires}; domain=${getDomainName()};path=/`;
}

export function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1);
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export function deleteCookie(name) {
	document.cookie = `${name}='';expires=${new Date()}; domain=${getDomainName()};path=/`;
	document.cookie = `${name}='';expires=${new Date()}; domain=${window.location.hostname};path=/`;
}

export function getDomainName() {
	let hostName = window.location.hostname;
	let dName = hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
	if (dName === hostName) {
		return dName;
	} else {
		return "." + dName;
	}
}

export const callCookieAPI = async (apiEndpoint) => await ky(apiEndpoint);

export default {
	setCookie,
	getCookie,
	deleteCookie,
	getDomainName,
	callCookieAPI
};
